module.exports = __webpack_public_path__ + "static/media/feature-admin.daf38445.png";